import Alpine from "alpinejs";
import { SignupForm } from "../utilities/Forms/SignupForm";
import { PasswordResetForm } from "../utilities/Forms/PasswordResetForm";

window.safeStartSpan({
    name: "jsAccounts file registered",
    op: "alpine.init",
});

document.addEventListener("alpine:init", () => {
    Alpine.data("signupForm", () => new SignupForm());
    Alpine.data("passwordResetForm", () => new PasswordResetForm());
});
